/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum MembershipTypes {
  free = 'free',
  gold = 'gold',
  silver = 'silver'
}

/**
 * MembershipTypes
 *
 * Membership types
 */
export const MembershipTypesEnumType = types.enumeration('MembershipTypes', ['free', 'gold', 'silver'])
